// src/components/pages/AccommodationCarousel.jsx
import React, { useMemo } from 'react';
import CrossfadeCarousel from './CrossfadeCarousel'; // adjust path if needed

export default function AccommodationCarousel() {
  const slides = useMemo(
    () => [
      { src: `${process.env.PUBLIC_URL}/images/accommodation/accom_1.jpg`,  alt: 'Accomodation 1' },
      { src: `${process.env.PUBLIC_URL}/images/accommodation/accom_2.jpg`,  alt: 'Accomodation 2' },
     { src: `${process.env.PUBLIC_URL}/images/accommodation/accom_3.jpg`,  alt: 'Accomodation 3' },
     { src: `${process.env.PUBLIC_URL}/images/accommodation/accom_4.jpg`,  alt: 'Accomodation 4' },
      { src: `${process.env.PUBLIC_URL}/images/accommodation/accom_5.jpg`,  alt: 'Accomodation 5' },
      { src: `${process.env.PUBLIC_URL}/images/accommodation/accom_6.jpg`,  alt: 'Accomodation 6' },
      { src: `${process.env.PUBLIC_URL}/images/accommodation/accom_7.jpg`,  alt: 'Accomodation 7' },
      { src: `${process.env.PUBLIC_URL}/images/accommodation/accom_8.jpg`,  alt: 'Accomodation 8' },
      { src: `${process.env.PUBLIC_URL}/images/accommodation/accom_9.jpg`,  alt: 'Accomodation 9' },
      { src: `${process.env.PUBLIC_URL}/images/accommodation/accom_10.jpg`,  alt: 'Accomodation 10' },
      { src: `${process.env.PUBLIC_URL}/images/accommodation/accom_11.jpg`,  alt: 'Accomodation 11' },
    ],
    []
  );

return (
    <CrossfadeCarousel slides={slides} aspectRatio="3/2" delay={5000} />
);
}
